import { AbstractValidator } from "fluent-ts-validator";
import { DCValidationResult } from "GlobalShared/haunted/HooksHelpers";
import { REQUIRED_MESSAGE } from "GlobalShared/helpers/stringHelper";
export const AllReturnGeneratedValidatorFieldNames = [
  "intrastatInValue",
  "intrastatInCurrency",
  "intrastatOutValue",
  "intrastatOutCurrency",
  "vatValue",
  "vatCurrency",
  "vatPaymentCategory"
];
export const AllSubmittedValidatorFieldNames = [
  "paymentReference"
];
export class ReturnGeneratedValidator extends AbstractValidator {
  constructor() {
    super();
    this.validateIfNumber((r) => r.intrastatInValue).isNotEmpty().withPropertyName("intrastatInValue").withFailureMessage("Number required").when((r) => r.isIntrastatInApplicable);
    this.validateIfString((r) => r.intrastatInCurrency).isNotEmpty().withPropertyName("intrastatInCurrency").withFailureMessage(REQUIRED_MESSAGE).when((r) => r.isIntrastatInApplicable);
    this.validateIfNumber((r) => r.intrastatOutValue).isNotEmpty().withPropertyName("intrastatOutValue").withFailureMessage(REQUIRED_MESSAGE).when((r) => r.isIntrastatOutApplicable);
    this.validateIfString((r) => r.intrastatOutCurrency).isNotEmpty().withPropertyName("intrastatOutCurrency").withFailureMessage(REQUIRED_MESSAGE).when((r) => r.isIntrastatOutApplicable);
    this.validateIfNumber((r) => r.vatValue).isNotEmpty().withPropertyName("vatValue").withFailureMessage("Number required").when((r) => r.isVATApplicable);
    this.validateIfString((r) => r.vatCurrency).isNotEmpty().withPropertyName("vatCurrency").withFailureMessage(REQUIRED_MESSAGE).when((r) => r.isVATApplicable);
    this.validateIfString((r) => r.vatPayment).isNotEmpty().withPropertyName("vatPaymentCategory").withFailureMessage(REQUIRED_MESSAGE).when((r) => r.isVATApplicable);
  }
  validateModel(item) {
    return new DCValidationResult(super.validate(item));
  }
}
export class SubmittedValidator extends AbstractValidator {
  constructor() {
    super();
    this.validateIfString((r) => r.paymentReference).isNotEmpty().withPropertyName("paymentReference").withFailureMessage(REQUIRED_MESSAGE).when((r) => r.isPaymentReferenceApplicable);
  }
  validateModel(item) {
    return new DCValidationResult(super.validate(item));
  }
}
